<template>
    <v-row>
      <v-col>
        <template v-for="content in widget.data.contents">
                  <span
                    style="width: 100% ; float: right"
                    v-html="content"
                  ></span>
        </template>
      </v-col>
    </v-row>
</template>

<script>
export default {
  name: "full-dynamic-html",
  props: {
    widget: Object
  }
}
</script>

<style scoped>

</style>
